module.exports = __webpack_public_path__ + "img/Taga_Veritas_Ako_63021.cd5709f2.jpg";